//ControlPanel.js
import React from 'react';
import { Box, Paper, Stack, Button} from '@mui/material';
import RecordButton from './components/RecordButton';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';

const ControlPanel = ({ 
    recording, 
    startRecording, 
    stopRecording, 
    waitTranscription, 
    language, 
    playbackRate, 
    handlePlaybackRateChange, 
    resetPlaybackRate, 
    playbBackInProgress, 
    recorded, 
    playbackRecording,
    audioURL 
}) => {
    const handlePlackBack = async () => {
        await playbackRecording(audioURL);
    } 
    return (
        <Paper 
            elevation={3} 
            sx={{ 
                backgroundColor: 'lavender', 
                px: 2,  // Horizontal padding only
                pt: 1,  // Reduced padding-top
                pb: 1,  // Padding bottom remains the same
                borderRadius: 2,
                position: 'relative',
                width: '100%',
                // maxWidth: 350, // Adjust as needed
                // margin: '0 auto' // Center on the page
            }}
        >
            {/* <Box sx = {{display:"flex", alignItems:"space-between", 
                        justifyContent: 'space-between', width : "100%",
                        mr:2}}>
            <Typography 
                variant="subtitle1"  // Smaller than h6
                sx={{ textAlign: 'center', mb: 1, mt: 0, lineHeight: 1.2 }} // Reduce line spacing
            >
                Record
            </Typography>
            <Typography 
                variant="subtitle1"  // Smaller than h6
                sx={{ textAlign: 'center', mb: 1, mt: 0, lineHeight: 1.2 }} // Reduce line spacing
            >
                Playback
            </Typography>
            </Box> */}

            <Stack  direction="row" 
                    spacing={2} 
                    justifyContent="space-between" 
                    alignItems="flex-start" 
                    width ='100%'>
                {/* Left: Record Button */}
                <RecordButton
                    recording={recording}
                    startRecording={startRecording}
                    stopRecording={stopRecording}
                    disabled ={waitTranscription || playbBackInProgress}
                    language = {language}
                    // sx={{ flexGrow: 1, height: '36px' , backgroundColor:"#2d4a7a"}}
                    sx={{ 
                        // flexGrow: 1, 
                        height: '36px' }}
                />
                {/* Right: Play Back Button */}
                <Box sx={{flexGrow:1}}></Box>
                <Button
                    title="Listen to yourself and compare it to the AI Voice"
                    // onClick={playbackRecording}
                    onClick = {handlePlackBack}
                    startIcon={<VolumeUpIcon />}
                    variant="contained"
                    color="primary"
                    disabled={!recorded || playbBackInProgress || waitTranscription}
                    sx={{ 
                        // flexGrow: 1, 
                        height: '36px' }}
                >
                    {/* Play Back */}
                    PLAY
                </Button>
            </Stack>

            {/* Bottom: Playback Slider */}
            {/* <Box sx={{ mt: 3 }}>
                <PlaybackSlider 
                    playbackRate={playbackRate}
                    handlePlaybackRateChange={handlePlaybackRateChange}
                    resetPlaybackRate={resetPlaybackRate}
                    limits={[1.0, 1.5]}
                    title="Speed up to match the native speaker and set your goal"
                />
            </Box> */}
        </Paper>
    );
};

export default ControlPanel;
